@if (btnConfig.isStroked) {
  <button mat-stroked-button color="primary"
    [ngStyle]="btnConfig.buttonStyle"
    [disabled]="btnConfig.disabled?.()"
    [id]="btnConfig.id"
    [type]="btnConfig.type ?? 'button'"
    (click)="btnConfig.onClick?.()">
    <ng-container *ngTemplateOutlet="buttonContent" />
  </button>
} @else {
  <button mat-flat-button color="primary"
    [id]="btnConfig.id"
    [ngStyle]="btnConfig.buttonStyle"
    [disabled]="btnConfig.disabled?.() || spinLoader"
    [attr.aria-busy]="appearance === 'login' ? !!spinLoader : null"
    [type]="btnConfig.type ?? 'button'"
    (click)="btnConfig.onClick?.()">
    <ng-container *ngTemplateOutlet="buttonContent" />
  </button>
}

<ng-template #buttonContent>
  <div class="d-flex align-items-center">
    @if (spinLoader && !btnConfig.isStroked) {
      @if (appearance === 'login') {
        <span class="login-button-spinner" aria-hidden="true"></span>
      } @else {
        <div class="loading-container">
          <mat-icon>hourglass_empty</mat-icon>
        </div>
      }
    } @else if (btnConfig.icon) {
      <i-tabler class="icon-20 m-r-8" [name]="btnConfig.icon" />
    }
    {{ ButtonText | translate }}
  </div>
</ng-template>
